import { render } from "./EmployeeSkillsAuditAssessment.vue?vue&type=template&id=b48d1b02&scoped=true"
import script from "./EmployeeSkillsAuditAssessment.vue?vue&type=script&lang=js"
export * from "./EmployeeSkillsAuditAssessment.vue?vue&type=script&lang=js"

import "./EmployeeSkillsAuditAssessment.vue?vue&type=style&index=0&id=b48d1b02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48d1b02"]])

export default __exports__